import { TemplateItemProps } from "apis";
import { lazy } from "react";

export const PageAdminTemplate = lazy(() => import("./List"));
export const PageAdminTemplateCreate = lazy(() => import("./Add"));
export const PageAdminTemplateUpdate = lazy(() => import("./Edit"));

export interface FormTemplateValuesProps extends TemplateItemProps { }